import { TOGGLE_ADD_FEEDS, TOGGLE_APPSMORE, TOGGLE_CUSTOMIZATION, TOGGLE_MANAGE_FEEDS_D, TOGGLE_PLAN, TOGGLE_THEMES_SECTION, TOGGLE_PUBLISH } from "../reducers/keys";

export const togglePlanSection = (toggleValue) => {
    return { type: TOGGLE_PLAN, payload: toggleValue }
}

export const toggleAppsMoreSection = (toggleValue) => {
    return { type: TOGGLE_APPSMORE, payload: toggleValue }
}

export const toggleAddFeedsSection = (toggleValue, route, navigate) => {
    if (route) navigate(route);
    return { type: TOGGLE_ADD_FEEDS, payload: toggleValue }
}
export const toggleManageSection = (toggleValue) => {
    return { type: TOGGLE_MANAGE_FEEDS_D, payload: toggleValue }
}
export const toggleThemesSection = (toggleValue) => {
    return { type: TOGGLE_THEMES_SECTION, payload: toggleValue }
}
export const toggleCustomizationSection = (toggleValue) => {
    return { type: TOGGLE_CUSTOMIZATION, payload: toggleValue }
}
export const togglePublishSection = (toggleValue) => {
    return { type: TOGGLE_PUBLISH, payload: toggleValue }
}